/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getMongoDataCollections } from '../fn/mongo-data/get-mongo-data-collections';
import { GetMongoDataCollections$Params } from '../fn/mongo-data/get-mongo-data-collections';
import { getMongoDataDocument } from '../fn/mongo-data/get-mongo-data-document';
import { GetMongoDataDocument$Params } from '../fn/mongo-data/get-mongo-data-document';
import { getMongoDataDocuments } from '../fn/mongo-data/get-mongo-data-documents';
import { GetMongoDataDocuments$Params } from '../fn/mongo-data/get-mongo-data-documents';
import { getMongoDataLiveBiddingAuctionParts } from '../fn/mongo-data/get-mongo-data-live-bidding-auction-parts';
import { GetMongoDataLiveBiddingAuctionParts$Params } from '../fn/mongo-data/get-mongo-data-live-bidding-auction-parts';
import { getMongoDataMaterialPriceFetches } from '../fn/mongo-data/get-mongo-data-material-price-fetches';
import { GetMongoDataMaterialPriceFetches$Params } from '../fn/mongo-data/get-mongo-data-material-price-fetches';
import { getMongoDataPrebidSourceResponse } from '../fn/mongo-data/get-mongo-data-prebid-source-response';
import { GetMongoDataPrebidSourceResponse$Params } from '../fn/mongo-data/get-mongo-data-prebid-source-response';
import { getMongoDataPrebidSourceResponses } from '../fn/mongo-data/get-mongo-data-prebid-source-responses';
import { GetMongoDataPrebidSourceResponses$Params } from '../fn/mongo-data/get-mongo-data-prebid-source-responses';
import { getMongoDataQuoteRelayFetches } from '../fn/mongo-data/get-mongo-data-quote-relay-fetches';
import { GetMongoDataQuoteRelayFetches$Params } from '../fn/mongo-data/get-mongo-data-quote-relay-fetches';
import { LiveBiddingAuctionPartDto } from '../models/live-bidding-auction-part-dto';
import { MaterialPriceFetchPointDto } from '../models/material-price-fetch-point-dto';
import { MongoDataCollectionDto } from '../models/mongo-data-collection-dto';
import { MongoDataDocumentDto } from '../models/mongo-data-document-dto';
import { MongoDataDocumentsDto } from '../models/mongo-data-documents-dto';
import { PrebidSourceResponseDetailDto } from '../models/prebid-source-response-detail-dto';
import { PrebidSourceResponsesDto } from '../models/prebid-source-responses-dto';
import { QuoteRelayFetchSeriesDto } from '../models/quote-relay-fetch-series-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedMongoDataService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getMongoDataCollections()` */
  static readonly GetMongoDataCollectionsPath = '/api/mongo-data/collections';

  /**
   * Lists the collections of the system's MongoDB with their size and time span.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMongoDataCollections()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMongoDataCollections$Response(params?: GetMongoDataCollections$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MongoDataCollectionDto>>> {
    return getMongoDataCollections(this.http, this.rootUrl, params, context);
  }

  /**
   * Lists the collections of the system's MongoDB with their size and time span.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMongoDataCollections$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMongoDataCollections(params?: GetMongoDataCollections$Params, context?: HttpContext): Observable<Array<MongoDataCollectionDto>> {
    return this.getMongoDataCollections$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MongoDataCollectionDto>>): Array<MongoDataCollectionDto> => r.body)
    );
  }

  /** Path part for operation `getMongoDataDocuments()` */
  static readonly GetMongoDataDocumentsPath = '/api/mongo-data/collections/{collection}/documents';

  /**
   * Pages through the documents of one collection, newest first.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMongoDataDocuments()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMongoDataDocuments$Response(params: GetMongoDataDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<MongoDataDocumentsDto>> {
    return getMongoDataDocuments(this.http, this.rootUrl, params, context);
  }

  /**
   * Pages through the documents of one collection, newest first.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMongoDataDocuments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMongoDataDocuments(params: GetMongoDataDocuments$Params, context?: HttpContext): Observable<MongoDataDocumentsDto> {
    return this.getMongoDataDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<MongoDataDocumentsDto>): MongoDataDocumentsDto => r.body)
    );
  }

  /** Path part for operation `getMongoDataDocument()` */
  static readonly GetMongoDataDocumentPath = '/api/mongo-data/collections/{collection}/documents/{id}';

  /**
   * Reads one document of a collection.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMongoDataDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMongoDataDocument$Response(params: GetMongoDataDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<MongoDataDocumentDto>> {
    return getMongoDataDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * Reads one document of a collection.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMongoDataDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMongoDataDocument(params: GetMongoDataDocument$Params, context?: HttpContext): Observable<MongoDataDocumentDto> {
    return this.getMongoDataDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<MongoDataDocumentDto>): MongoDataDocumentDto => r.body)
    );
  }

  /** Path part for operation `getMongoDataMaterialPriceFetches()` */
  static readonly GetMongoDataMaterialPriceFetchesPath = '/api/mongo-data/material-price-fetches';

  /**
   * Every archived material price fetch in a time range, oldest first, for the price chart.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMongoDataMaterialPriceFetches()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMongoDataMaterialPriceFetches$Response(params: GetMongoDataMaterialPriceFetches$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MaterialPriceFetchPointDto>>> {
    return getMongoDataMaterialPriceFetches(this.http, this.rootUrl, params, context);
  }

  /**
   * Every archived material price fetch in a time range, oldest first, for the price chart.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMongoDataMaterialPriceFetches$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMongoDataMaterialPriceFetches(params: GetMongoDataMaterialPriceFetches$Params, context?: HttpContext): Observable<Array<MaterialPriceFetchPointDto>> {
    return this.getMongoDataMaterialPriceFetches$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MaterialPriceFetchPointDto>>): Array<MaterialPriceFetchPointDto> => r.body)
    );
  }

  /** Path part for operation `getMongoDataQuoteRelayFetches()` */
  static readonly GetMongoDataQuoteRelayFetchesPath = '/api/mongo-data/quote-relay-fetches';

  /**
   * The fetches of the quote relay in a time range, oldest first, in intervals that grow with the range, for its chart.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMongoDataQuoteRelayFetches()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMongoDataQuoteRelayFetches$Response(params: GetMongoDataQuoteRelayFetches$Params, context?: HttpContext): Observable<StrictHttpResponse<QuoteRelayFetchSeriesDto>> {
    return getMongoDataQuoteRelayFetches(this.http, this.rootUrl, params, context);
  }

  /**
   * The fetches of the quote relay in a time range, oldest first, in intervals that grow with the range, for its chart.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMongoDataQuoteRelayFetches$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMongoDataQuoteRelayFetches(params: GetMongoDataQuoteRelayFetches$Params, context?: HttpContext): Observable<QuoteRelayFetchSeriesDto> {
    return this.getMongoDataQuoteRelayFetches$Response(params, context).pipe(
      map((r: StrictHttpResponse<QuoteRelayFetchSeriesDto>): QuoteRelayFetchSeriesDto => r.body)
    );
  }

  /** Path part for operation `getMongoDataPrebidSourceResponses()` */
  static readonly GetMongoDataPrebidSourceResponsesPath = '/api/mongo-data/prebid-source-responses';

  /**
   * Pages through the archived answers of the prebid source systems, newest first and without their bodies.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMongoDataPrebidSourceResponses()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMongoDataPrebidSourceResponses$Response(params: GetMongoDataPrebidSourceResponses$Params, context?: HttpContext): Observable<StrictHttpResponse<PrebidSourceResponsesDto>> {
    return getMongoDataPrebidSourceResponses(this.http, this.rootUrl, params, context);
  }

  /**
   * Pages through the archived answers of the prebid source systems, newest first and without their bodies.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMongoDataPrebidSourceResponses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMongoDataPrebidSourceResponses(params: GetMongoDataPrebidSourceResponses$Params, context?: HttpContext): Observable<PrebidSourceResponsesDto> {
    return this.getMongoDataPrebidSourceResponses$Response(params, context).pipe(
      map((r: StrictHttpResponse<PrebidSourceResponsesDto>): PrebidSourceResponsesDto => r.body)
    );
  }

  /** Path part for operation `getMongoDataPrebidSourceResponse()` */
  static readonly GetMongoDataPrebidSourceResponsePath = '/api/mongo-data/prebid-source-responses/{id}';

  /**
   * Reads one archived answer of a prebid source system with its body.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMongoDataPrebidSourceResponse()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMongoDataPrebidSourceResponse$Response(params: GetMongoDataPrebidSourceResponse$Params, context?: HttpContext): Observable<StrictHttpResponse<PrebidSourceResponseDetailDto>> {
    return getMongoDataPrebidSourceResponse(this.http, this.rootUrl, params, context);
  }

  /**
   * Reads one archived answer of a prebid source system with its body.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMongoDataPrebidSourceResponse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMongoDataPrebidSourceResponse(params: GetMongoDataPrebidSourceResponse$Params, context?: HttpContext): Observable<PrebidSourceResponseDetailDto> {
    return this.getMongoDataPrebidSourceResponse$Response(params, context).pipe(
      map((r: StrictHttpResponse<PrebidSourceResponseDetailDto>): PrebidSourceResponseDetailDto => r.body)
    );
  }

  /** Path part for operation `getMongoDataLiveBiddingAuctionParts()` */
  static readonly GetMongoDataLiveBiddingAuctionPartsPath = '/api/mongo-data/live-bidding-auction-parts';

  /**
   * The started parts of the auctions that started last, newest first, each with the window its live bidding metrics are read from. `take` counts auctions, not parts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMongoDataLiveBiddingAuctionParts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMongoDataLiveBiddingAuctionParts$Response(params?: GetMongoDataLiveBiddingAuctionParts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LiveBiddingAuctionPartDto>>> {
    return getMongoDataLiveBiddingAuctionParts(this.http, this.rootUrl, params, context);
  }

  /**
   * The started parts of the auctions that started last, newest first, each with the window its live bidding metrics are read from. `take` counts auctions, not parts.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMongoDataLiveBiddingAuctionParts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMongoDataLiveBiddingAuctionParts(params?: GetMongoDataLiveBiddingAuctionParts$Params, context?: HttpContext): Observable<Array<LiveBiddingAuctionPartDto>> {
    return this.getMongoDataLiveBiddingAuctionParts$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LiveBiddingAuctionPartDto>>): Array<LiveBiddingAuctionPartDto> => r.body)
    );
  }

}
